import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OwlDateTimeModule, OwlNativeDateTimeModule, OWL_DATE_TIME_FORMATS } from 'ng-pick-datetime';
import { NgxWebstorageModule } from 'ngx-webstorage';
import { NgSelectModule } from '@ng-select/ng-select';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { ChartsModule } from 'ng2-charts';
import { TextMaskModule } from 'angular2-text-mask';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ContextMenuModule } from 'ngx-contextmenu';
import { ColorPickerModule } from 'ngx-color-picker';

import { SpinnerModule, TableModule, AutocompleteModule } from './modules'

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

export const MY_NATIVE_FORMATS = {
  fullPickerInput: {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true},
  datePickerInput: {year: 'numeric', month: 'numeric', day: 'numeric'},
  timePickerInput: {hour: 'numeric', minute: 'numeric'},
  monthYearLabel: {year: 'numeric', month: 'short'},
  dateA11yLabel: {year: 'numeric', month: 'long', day: 'numeric'},
  monthYearA11yLabel: {year: 'numeric', month: 'long'},
};

import {
  ModalPopupComponent,
  IconComponent,
  LoaderComponent,
  SpinnerComponent,
  ConfirmationDialogComponent,
  AudioControllerComponent,
  ValidationErrorsComponent
} from './components';

import {
  CurrencyFormat,
  RemoveUnderscorePipe,
  CapitalizeFirstPipe,
  FormatTimestamp,
  FormatPhoneNumberPipe,
  ArrayJoinPipe
} from './pipes';
import { AsideToggleDirective, ClickOutsideDirective } from './directives';
import { ToasterService, ConfirmationDialogService, StorageService } from './services';
import { AuthInterceptor } from './interceptor';
import { AccessChecker, IsGrantedDirective } from './security'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    HttpClientModule,
    TranslateModule.forChild({}),
    NgxWebstorageModule.forRoot({ prefix: 'salesonepro', separator: '|'}),
    ContextMenuModule.forRoot({
      useBootstrap4: true,
    }),
    NgbModule.forRoot(),
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    NgSelectModule,
    PerfectScrollbarModule,
    ChartsModule,
    SpinnerModule,
    TableModule,
    AutocompleteModule,
    InfiniteScrollModule,
    ColorPickerModule
  ],

  declarations: [
    SpinnerComponent,
    LoaderComponent,
    IconComponent,
    ModalPopupComponent,
    ConfirmationDialogComponent,
    IsGrantedDirective,
    AsideToggleDirective,
    ClickOutsideDirective,
    CurrencyFormat,
    FormatTimestamp,
    RemoveUnderscorePipe,
    FormatPhoneNumberPipe,
    ArrayJoinPipe,
    AudioControllerComponent,
    ValidationErrorsComponent,
    CapitalizeFirstPipe
  ],
  exports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    RouterModule,
    SpinnerComponent,
    LoaderComponent,
    IconComponent,
    ModalPopupComponent,
    IsGrantedDirective,
    AsideToggleDirective,
    ClickOutsideDirective,
    PerfectScrollbarModule,
    NgbModule,
    OwlDateTimeModule,
    NgSelectModule,
    ChartsModule,
    CurrencyFormat,
    FormatTimestamp,
    RemoveUnderscorePipe,
    FormatPhoneNumberPipe,
    CapitalizeFirstPipe,
    ArrayJoinPipe,
    TextMaskModule,
    AudioControllerComponent,
    ValidationErrorsComponent,
    ContextMenuModule,
    SpinnerModule,
    TableModule,
    AutocompleteModule,
    InfiniteScrollModule,
    ColorPickerModule
  ],
  providers: [
    ToasterService,
    ConfirmationDialogService,
    StorageService,
    AccessChecker,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    {
      provide: OWL_DATE_TIME_FORMATS,
      useValue: MY_NATIVE_FORMATS
    }
  ],
  entryComponents: [ ConfirmationDialogComponent ]
})
export class SharedModule {}
